
export module MPC_PricemodeSettingModule {
    export let espp_mpc_default_pricemode: string;
}